import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

const DISMISS_KEY = (uid) => `keyflow:msgOnboardingDismissed:${uid}`;

export default function MessagingOnboardingBanner({ workspace, currentUserUid }) {
    const [dismissed, setDismissed] = useState(() => {
        if (typeof window === 'undefined') return false;
        return sessionStorage.getItem(DISMISS_KEY(currentUserUid)) === '1';
    });

    const needsOnboarding = useMemo(() => {
        if (!workspace || !currentUserUid) return false;
        const entry = workspace.memberDirectory?.[currentUserUid];
        const hasPhone = typeof entry?.phone === 'string' && entry.phone.trim() !== '';
        const hasConsent = entry?.messageConsent?.granted === true;
        return !(hasPhone && hasConsent);
    }, [workspace, currentUserUid]);

    if (!needsOnboarding || dismissed) return null;

    const handleDismiss = () => {
        sessionStorage.setItem(DISMISS_KEY(currentUserUid), '1');
        setDismissed(true);
    };

    return (
        <div className="border-b border-[color:var(--color-warning)]/20 bg-[color:var(--surface-warning)] px-4 py-2 text-sm text-[color:var(--color-warning)]">
            <div className="mx-auto flex max-w-7xl items-center justify-between gap-3">
                <span>
                    Add your phone and consent to receive transaction text reminders.
                </span>
                <div className="flex items-center gap-3">
                    <Link to="/settings" className="font-medium underline">Set up</Link>
                    <button
                        type="button"
                        onClick={handleDismiss}
                        className="rounded px-2 py-0.5 text-xs text-[color:var(--color-warning)] hover:bg-[color:var(--surface-warning)]"
                    >
                        Skip
                    </button>
                </div>
            </div>
        </div>
    );
}
